import animation from "./animation";
export default {
    up(node, listener) {
        this.run(node, 'slide-up', listener);
    },
    down(node, listener) {
        this.run(node, 'slide-down', listener);
    },
    run(node, mode, listener) {
        try {
            const appHeight = node.offsetHeight;
            // console.log(mode,node,appHeight)
            let b = 0; // 初始值
            let c; // 变化量
            let d = 0.3; // 持续时间
            let h; // 目标值
        
            // js动画方案
            // 初始化
            if (mode == 'slide-up') {
                node.style.cssText = "transform: translate3d(0, 100%, 0);opacity: 1";    
            } else {
                // node.style.cssText = "transform: translate3d(0, 0, 0);opacity: 1";
            }   
            
            c = h = parseFloat(appHeight);

            const setApp = function (c, isEnd) {
                if (isEnd) {
                    if (mode == 'slide-up') {
                        node.style.cssText = "transform: translate3d(0, 0, 0);";
                    } else {
                        node.style.cssText = "transform: translate3d(0, 100%, 0);";
                    }
                    if (typeof listener === 'function') {
                      listener();
                    }
                } else {
                    if (mode == 'slide-up') {
                        node.style.cssText = `transform: translate3d(0, ${h - c}px, 0);`;
                    } else {
                        node.style.cssText = `transform: translate3d(0, ${c}px, 0);`;
                    }
                }
            };
            animation.run(b, c, d, setApp);
        } catch (e) {
            // 回到css3 方案
            node.classList.remove('slide-up')
            node.classList.remove('slide-down')
            node.classList.add(mode)
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/assets/animation/slide.js